module.exports = __webpack_public_path__ + "img/padecimientoCara.3e3def45.svg";